import { useEffect, useState } from 'react';
import { api, ChangeLog } from '@/lib/api';
import { cn } from '@/lib/utils';

const ACTION_STYLES: Record<ChangeLog['action'], string> = {
  create: 'bg-emerald-100 text-emerald-800',
  update: 'bg-blue-100 text-blue-800',
  delete: 'bg-red-100 text-red-800',
  reorder: 'bg-amber-100 text-amber-800',
};

function formatWhen(iso: string): string {
  const d = new Date(iso.replace(' ', 'T') + 'Z');
  const diff = Date.now() - d.getTime();
  const min = Math.floor(diff / 60_000);
  if (min < 1) return '방금';
  if (min < 60) return `${min}분 전`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}시간 전`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}일 전`;
  return d.toISOString().slice(0, 10);
}

export function ChangeLogPanel({ reloadKey }: { reloadKey: number }) {
  const [logs, setLogs] = useState<ChangeLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api
      .listChangeLog(20)
      .then((l) => alive && setLogs(l))
      .catch(() => alive && setLogs([]))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [reloadKey]);

  return (
    <div className="rounded-md border bg-card">
      <div className="border-b px-4 py-2 text-sm font-semibold">변경 이력 (최근 20)</div>
      <div className="max-h-[70vh] overflow-auto">
        {loading && <div className="p-4 text-xs text-muted-foreground">로드 중…</div>}
        {!loading && logs.length === 0 && <div className="p-4 text-xs text-muted-foreground">이력 없음</div>}
        {logs.map((log) => (
          <div key={log.id} className="border-b px-4 py-2 text-xs last:border-b-0">
            <div className="flex items-center gap-2">
              <span className={cn('rounded px-1.5 py-0.5 text-[10px] font-medium', ACTION_STYLES[log.action])}>
                {log.action}
              </span>
              <span className="text-muted-foreground">{formatWhen(log.created_at)}</span>
              {log.item_id !== null && <span className="text-muted-foreground">#{log.item_id}</span>}
            </div>
            <div className="mt-1 truncate text-muted-foreground">{log.actor_email}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
